// removed by extract-text-webpack-plugin
module.exports = {"link":"_3m7rQUAMZv-mTTJ2","title":"_1lBZ-g-qSvvxvwW0","field":"_2tDvx9D4yQvOh7qh","label":"XKDEaomtFxALrHcb","input":"_1rPU_O5L8p-gqLme","controls":"_3qtEkyN70ZZc75ie","cancel":"_3vob3H8Y8K26NjUY","delete":"_1D-Vh9yN0yreUcUk"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/EditorLink/EditorLink.pcss
// module id = 487
// module chunks = 1